import { React, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import SchoolIcon from "@mui/icons-material/School";
import DownloadIcon from "@mui/icons-material/Download";
import classes from "./LearnPointFramework.module.css";
import AsttButton from "../../AsttButton/AsttButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { useNavigate } from "react-router-dom";
import SnackBar from "components/SnackBar/SnackBar";
import {
  getAllParentClients,
  getAllSiteCodes,
  getclientData,
  getprojectData,
  getprogramData,
  filterFrameWorks,
  getAllClassTypes,
} from "../../../services/learnPointUserServices";
import AsttButtonLight from "components/ASTTButtonLight/AsttButtonLight";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import BackdropComponent from "../../../components/Spinner/Spinner";
import moment from "moment";
import {
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import exportAsCsv from "utils/exportAsCsv";
import PrimeReactDataGrid from "../../PrimeReactDataGrid/PrimeReactDataGrid";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import applicationUsageLog from "../../../utils/applicationUsagesLog";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useAuth } from "context/AuthContext";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const ToolTipWrap = (paramText) => {
  return (
    <Tooltip title={paramText}>
      <p>{paramText}</p>
    </Tooltip>
  );
};

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{ fontSize: "1.5rem", color: "green", fontWeight: "bold" }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const PrepareProjectContent = (props) => {
  const details = props?.details;
  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12} className={classes.panelHeader}>
        <p className={classes.panelHeaderText}>Projects</p>
      </Grid>
      <Grid item xs={12} className={classes.panelHeader}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <List>
          {details?.map((projectName) => {
            return (
              <ListItem key={projectName}>
                <ListItemText primary={projectName}></ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
};

PrepareProjectContent.propTypes = {
  details: PropTypes.array.isRequired,
};

const PrepareSiteContent = (props) => {
  const details = props?.details;
  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12} className={classes.panelHeader}>
        <p className={classes.panelHeaderText}>Sites</p>
      </Grid>
      <Grid item xs={12} className={classes.panelHeader}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <List>
          {details?.map((siteName) => {
            return (
              <ListItem key={siteName}>
                <ListItemText primary={siteName}></ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </Grid>
  );
};

PrepareSiteContent.propTypes = {
  details: PropTypes.array.isRequired,
};

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));

const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  padding: "6px 20px",

  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

export default function Frameworks() {
  const [readOnlyFramework, setReadOnlyFramework] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    const validateAccess = () => {
      if (hasPermission("LD_Group_Admin")) {
        setReadOnlyFramework(false);
      }
      window.localStorage.removeItem("LPHome");
    };

    validateAccess();

    applicationUsageLog(
      localStorage.getItem("User"),
      localStorage.getItem("EmailId"),
      "LearnPoint",
      "Framework",
    );
  }, [hasPermission]);
  const navigate = useNavigate();

  const [editAccess, setEditAccess] = useState(false);
  const [expanded, setExpanded] = useState("panel1");
  const [loader, setLoader] = useState(false);
  const [parentClientDetail, setParentClientDetail] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [classTypeData, setClassTypeData] = useState([]);

  const initialClassTypeValue = {
    ClassTypeId: 1,
    ClassTypeCode: "NH",
    ClassTypeName: "New Hire",
  };

  const [classTypeValue, setClassTypeValue] = useState(initialClassTypeValue);

  const initialClientValue = {
    ClientId: 0,
    ClientCode: "",
    ClientName: "",
  };

  const initialProgramValue = {
    ProgramId: 0,
    ProgramName: "",
    ProgramCode: "",
  };

  const initialProjectValue = {
    ProjectId: 0,
    ProjectName: "",
    ProjectCode: "",
  };

  const initialParentClientValue = {
    ParentClientId: 0,
    ParentClientName: "",
    ParentClientCode: "",
  };

  const initialFrameworkStatus = {
    active: true,
    future: false,
    expired: false,
  };

  const [clientValue, setClientValue] = useState(initialClientValue);

  const [programValue, setProgramValue] = useState(initialProgramValue);

  const [projectValue, setProjectValue] = useState(initialProjectValue);

  const [parentClientValue, setParentClientValue] = useState(
    initialParentClientValue,
  );

  const [frameworkStatus, setFrameworkStatus] = useState(
    initialFrameworkStatus,
  );

  const initialCountryValue = {
    Country: "",
    CountryCode: "",
  };

  const initialSiteValue = {
    GeoLocCd: "",
    GeoLocName: "",
    GeoLocationId: 0,
    CountryCode: "",
  };

  const [selectedCountry, setSelectedCountry] = useState(initialCountryValue);

  const [selectedSite, setSelectedSite] = useState(initialSiteValue);
  const [rows, setRows] = useState([]);
  const frameworkNameRef = useRef("");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [allGeoLocData, setAllGeoLocData] = useState([]);

  const handleChangePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const [panelOpen, setPanelOpen] = useState(false);
  const [panelDetails, setPanelDetails] = useState([]);

  const [panelType, setPanelType] = useState("site");

  const setAccess = () => {
    if (hasPermission("LD_Group_Admin")) {
      setEditAccess(true);
    }
  };

  useEffect(() => {
    setAccess();
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        // API call to get all parent client details, all sites, all country codes.

        const parentClientDetails = await getAllParentClients();

        if (cancelled) return;

        if (parentClientDetails?.message === "Success") {
          if (!cancelled) {
            setParentClientDetail(parentClientDetails?.data);
          }
        }

        const countryCode = await getAllSiteCodes();

        if (cancelled) return;

        if (countryCode?.message === "Success") {
          if (!cancelled) {
            setAllGeoLocData(countryCode?.data);
            setCountryData(prepareCountryData(countryCode?.data));
          }
        }

        const classTypeDetails = await getAllClassTypes();

        if (cancelled) return;

        if (classTypeDetails?.message === "Success") {
          if (!cancelled) {
            setClassTypeData(classTypeDetails?.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  const resetCascadingFilters = () => {
    setClientValue(initialClientValue);

    setProgramValue(initialProgramValue);

    setProjectValue(initialProjectValue);
  };

  const handleParentClientChange = async (event, value) => {
    if (value) {
      resetCascadingFilters();
      setParentClientValue(value);

      const projectResults = await getprojectData(value?.ParentClientId);
      if (projectResults?.message === "Success") {
        setProjectData(projectResults?.data);
      }

      const clientResults = await getclientData(value?.ParentClientId);
      if (clientResults?.message === "Success") {
        setClientData(clientResults?.data);
      }

      const programResults = await getprogramData(value?.ParentClientId);
      if (programResults?.message === "Success") {
        setProgramData(programResults?.data);
      }
    } else {
      setParentClientValue(initialParentClientValue);
    }
  };

  const handleCountryChange = (event, value) => {
    if (value) {
      setSelectedSite(initialSiteValue);
      setSelectedCountry(value);
      const sites = allGeoLocData?.filter(
        (item) => item?.CountryCode === value?.CountryCode,
      );
      setSiteData(sites);
    } else {
      setSelectedCountry(initialCountryValue);
    }
  };
  const handleCreateNewFramework = () => {
    navigate(`/learnpoint/infoSection/Classes`, {
      state: {
        action: "create",
        frameworkId: 0,
      },
    });
  };

  const prepareGridResults = (data) => {
    return data.map((item) => ({
      ...item,
      id: item?.frameworkId,
      country: item?.searchGeoLocationResponses[0]?.country,
      site: item?.searchGeoLocationResponses
        ?.map((item) => `${item?.site} (${item?.siteCode})`)
        .join("|"),
      parentClient: item?.searchProjectResponses[0]?.parentClientName,
      client: item?.searchProjectResponses[0]?.clientName,
      program: item?.searchProjectResponses[0]?.programName,
      project: item?.searchProjectResponses
        ?.map((item) => item?.projectName)
        .join("|"),
      effectiveDate:
        item?.effectiveDate != null
          ? moment(item?.effectiveDate).format("YYYY-MM-DD")
          : "",
      expireDate:
        item?.expireDate != null
          ? moment(item?.expireDate).format("YYYY-MM-DD")
          : "",
      createdDate:
        item?.createdDate != null
          ? moment(item?.createdDate).format("YYYY-MM-DD")
          : "",
      modifiedDate:
        item?.modifiedDate != null
          ? moment(item?.modifiedDate).format("YYYY-MM-DD")
          : "",
    }));
  };

  const prepareCountryData = (data) => {
    const countries = data?.map((country) => ({
      CountryCode: country?.CountryCode,
      Country: country?.Country,
    }));

    let distinctCountries = [
      ...new Map(countries?.map((item) => [item["Country"], item])).values(),
    ];

    return distinctCountries;
  };

  const prepareCountryPayload = (CountryCode) => {
    return allGeoLocData
      ?.filter((country) => country?.CountryCode === CountryCode)
      ?.map((item) => ({
        geoLocationId: item?.GeoLocationId,
      }));
  };

  const prepareStatusPayload = () => {
    const { active, future, expired } = frameworkStatus;
    let statusPayload = [];
    [
      { id: 2, selected: active },
      { id: 3, selected: future },
      { id: 4, selected: expired },
    ].forEach((status) => {
      status?.selected && statusPayload?.push({ statusId: status.id });
    });
    return statusPayload;
  };

  const prepareProjectPayload = () => {
    const projectIds = projectData?.filter(
      (project) =>
        project?.ClientId ===
          (clientValue?.ClientId > 0
            ? clientValue?.ClientId
            : project?.ClientId) &&
        project?.ProgramId ===
          (programValue?.ProgramId > 0
            ? programValue?.ProgramId
            : project?.ProgramId) &&
        project?.ProjectId ===
          (projectValue?.ProjectId > 0
            ? projectValue?.ProjectId
            : project?.ProjectId),
    );
    return projectIds?.map((item) => ({ projectId: item?.ProjectId }));
  };

  const prepareSitePayload = () => {
    const geoLocations = siteData?.filter(
      (site) =>
        site?.GeoLocationId ===
        (selectedSite?.GeoLocationId > 0
          ? selectedSite?.GeoLocationId
          : site?.GeoLocationId),
    );

    return geoLocations?.map((item) => ({
      geoLocationId: item?.GeoLocationId,
    }));
  };

  const handleFindFrameworks = async () => {
    if (!validateFrameworkStatus(frameworkStatus)) {
      try {
        setLoader(true);
        const payload = {
          ...(frameworkNameRef.current?.value !== "" &&
            frameworkNameRef.current?.value !== null && {
              framework: frameworkNameRef?.current.value,
            }),
          classTypeId: classTypeValue?.ClassTypeId,
          ...(parentClientValue.ParentClientCode !== "" && {
            projectIds: prepareProjectPayload(),
          }),
          ...(selectedCountry.CountryCode !== "" && {
            geoLocationIds:
              selectedSite.GeoLocationId !== 0
                ? prepareSitePayload()
                : prepareCountryPayload(selectedCountry.CountryCode),
          }),
          statusIds: prepareStatusPayload(),
        };

        const filterFrameworkResults = await filterFrameWorks(payload);
        if (filterFrameworkResults?.statusCode === 200) {
          setRows(prepareGridResults(filterFrameworkResults?.data));
          setLoader(false);
          setExpanded(false);
        } else if (filterFrameworkResults?.statusCode === 404) {
          setRows([]);
          setLoader(false);
          setSnack({
            open: true,
            message: "No results found.",
            severity: "info",
          });
        } else {
          setRows([]);
          setLoader(false);
          setSnack({
            open: true,
            message: "Some internal error occured.",
            severity: "error",
          });
        }
      } catch (e) {
        setRows([]);

        setLoader(false);
        setSnack({
          open: true,
          message: "Some internal error occured.",
          severity: "error",
        });
      }
    }
  };

  const handleReset = () => {
    setLoader(true);
    setClientData([]);
    setProgramData([]);
    setProjectData([]);
    setSiteData([]);
    setClassTypeValue(initialClassTypeValue);
    setParentClientValue(initialParentClientValue);
    resetCascadingFilters();

    setFrameworkStatus(initialFrameworkStatus);

    setSelectedCountry(initialCountryValue);

    setSelectedSite(initialSiteValue);
    setRows([]);
    if (frameworkNameRef.current !== null) {
      frameworkNameRef.current.value = "";
    }
    setLoader(false);
  };
  const handleStatusCheckbox = (event) => {
    setFrameworkStatus({
      ...frameworkStatus,
      [event?.target?.id]: event?.target?.checked,
    });

    if (!event?.target?.checked)
      validateFrameworkStatus({
        ...frameworkStatus,
        [event?.target?.id]: event?.target?.checked,
      });
  };

  const validateFrameworkStatus = (frameworkStatus) => {
    const { active, future, expired } = frameworkStatus;
    const frameworkStatusError =
      [active, future, expired].filter((v) => v).length < 1;

    if (frameworkStatusError) {
      setSnack({
        open: true,
        message: "Please select atleast one framework status.",
        severity: "error",
      });
    }
    return frameworkStatusError;
  };

  const editRowTemplate = (params) => (
    <IconButton
      {...{ className: classes.editButton }}
      onClick={() => handleRowClick(params)}
    >
      {editAccess === true ? <EditIcon /> : <PreviewIcon />}
    </IconButton>
  );

  const handleRowClick = (params) => {
    navigate(`/learnpoint/infoSection/Classes`, {
      state: {
        action: "update",
        frameworkId: params?.id,
      },
    });
  };

  const FindRelatedClassTemplate = (params) => {
    const isDisabled = params.classRosterId === 0;
    return (
      <IconButton
        onClick={() => handleClassClick(params)}
        disabled={isDisabled}
        title={isDisabled ? "No Related Classes" : "Find Related Classes"}
      >
        <SchoolIcon sx={{ color: isDisabled ? "inherit" : "#3299FF" }} />
      </IconButton>
    );
  };

  const handleClassClick = (params) => {
    navigate(`/learnpoint/infoSection/ClassRoster`, {
      state: params.classRosterId,
    });
  };

  const filterProps = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    framework: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    description: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    effectiveDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    expireDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    frameworkStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    country: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    site: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    parentClient: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    client: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    program: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    project: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    createdBy: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    createdDate: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modifiedBy: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modifiedDate: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };

  const columns = [
    {
      field: "id",
      header: "Edit",
      style: { minWidth: "1rem" },
      filter: false,
      body: (params) => editRowTemplate(params),
    },
    {
      field: "classRosterId",
      style: { minWidth: "1rem" },
      filter: false,
      body: (params) => FindRelatedClassTemplate(params),
    },
    {
      field: "framework",
      header: "Framework Name",
      style: { minWidth: "12rem" },
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Framework name",
    },
    {
      field: "description",
      header: "Framework Description",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Framework Description",
      style: { minWidth: "12rem" },
      body: (params) => ToolTipWrap(params?.description),
    },
    {
      field: "effectiveDate",
      header: "Effective Date",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Effective Date",
      style: { minWidth: "12rem" },
    },
    {
      field: "expireDate",
      header: "Expiry Date",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Expiry Date",
      style: { minWidth: "12rem" },
    },
    {
      field: "frameworkStatus",
      header: "Status",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Status",
      style: { minWidth: "12rem" },
    },
    {
      field: "country",
      header: "Country",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Country",
      style: { minWidth: "12rem" },
      body: (params) => ToolTipWrap(params?.country),
    },
    {
      field: "site",
      header: "Site",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Site",
      style: { minWidth: "12rem" },
      body: (params) => preparePanel(params, "site"),
    },
    {
      field: "parentClient",
      header: "Parent Client",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Parent Client",
      style: { minWidth: "12rem" },
      body: (params) => ToolTipWrap(params?.parentClient),
    },
    {
      field: "client",
      header: "Client",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Client",
      style: { minWidth: "12rem" },
      body: (params) => ToolTipWrap(params?.client),
    },
    {
      field: "program",
      header: "Program",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Program",
      style: { minWidth: "12rem" },
      body: (params) => ToolTipWrap(params?.program),
    },
    {
      field: "project",
      header: "Project",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Project",
      style: { minWidth: "12rem" },
      body: (params) => preparePanel(params, "project"),
    },
    {
      field: "createdBy",
      header: "Created By",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Created By",
      style: { minWidth: "12rem" },
    },
    {
      field: "createdDate",
      header: "Created Date",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Created Date",
      style: { minWidth: "12rem" },
    },
    {
      field: "modifiedBy",
      header: "Modified By",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Modified By",
      style: { minWidth: "12rem" },
    },
    {
      field: "modifiedDate",
      header: "Modified Date",
      filter: true,
      sortable: true,
      filterPlaceholder: "Search by Modified Date",
      style: { minWidth: "12rem" },
    },
  ];

  const preparePanel = (param, type) => {
    const details = param[type]?.split("|");
    if (details?.length === 1) {
      return (
        <Tooltip title={details[0]}>
          <p>{details[0]}</p>
        </Tooltip>
      );
    } else {
      return (
        <Button variant="text" onClick={() => handleSidePanel(type, details)}>
          <p className={classes.gridText}>
            {type === "site" ? "VIEW SITES" : "VIEW PROJECTS"}
          </p>
        </Button>
      );
    }
  };

  const footer = `Total records : ${rows ? rows.length : 0}`;

  const handleSidePanel = (panelType, panelDetails) => {
    setPanelType(panelType);
    setPanelDetails(panelDetails);
    setPanelOpen(!panelOpen);
  };

  const handleSidePanelClose = () => {
    setPanelOpen(!panelOpen);
  };

  const handleExportClick = () => {
    const columnsData = columns.map((column) => ({
      ...column,
      headerName: column?.header === "Edit" ? "Id" : column?.header,
    }));
    exportAsCsv(rows, columnsData, "LearnpointExport");
  };

  return (
    <>
      {loader ? <BackdropComponent /> : null}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChangePanel("panel1")}
      >
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          expandIcon={<ExpandMoreIcon />}
        >
          <p className={classes.headerText}>Framework</p>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1} className={classes.gridContainer}>
            <Grid item xs={1.5}>
              <p className={classes.fieldText}>Framework Name :</p>
            </Grid>
            <Grid item xs={4}>
              <TextField
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 32,
                    border: "1px solid #d3d3d3",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                placeholder="Framework name"
                id="outlined-start-adornment"
                size="small"
                fullWidth
                inputRef={frameworkNameRef}
              />
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={1}>
              <p className={classes.fieldText}> Parent client : </p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                disablePortal
                blurOnSelect
                options={parentClientDetail}
                value={parentClientValue}
                onChange={handleParentClientChange}
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                getOptionLabel={(option) =>
                  option?.ParentClientName === ""
                    ? ""
                    : option?.ParentClientName
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Parent Client"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5}>
              <p className={classes.fieldText}>Class Type :</p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                disablePortal
                blurOnSelect
                options={classTypeData}
                value={classTypeValue}
                onChange={(event, value) => {
                  if (value) {
                    setClassTypeValue(value);
                  } else {
                    setClassTypeValue(initialClassTypeValue);
                  }
                }}
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                getOptionLabel={(option) =>
                  option?.ClassTypeId === 0 ? "" : option?.ClassTypeName
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Class Type"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={1}>
              <p className={classes.fieldText}> Client : </p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                blurOnSelect
                disablePortal
                value={clientValue}
                options={clientData}
                onChange={(event, value) => {
                  if (value) {
                    setClientValue(value);
                  } else {
                    setClientValue(initialClientValue);
                  }
                }}
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                getOptionLabel={(option) =>
                  option?.ClientName === "" ? "" : option?.ClientName
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Client"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5}>
              <p className={classes.fieldText}> Country : </p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                blurOnSelect
                disablePortal
                options={countryData}
                value={selectedCountry}
                onChange={handleCountryChange}
                getOptionLabel={(option) =>
                  option?.Country === "" ? "" : option?.Country
                }
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Country"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={1}>
              <p className={classes.fieldText}> Program : </p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                blurOnSelect
                disablePortal
                value={programValue}
                options={programData}
                onChange={(event, value) => {
                  if (value) {
                    setProgramValue(value);
                  } else {
                    setProgramValue(initialProgramValue);
                  }
                }}
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                getOptionLabel={(option) =>
                  option.ProgramName === "" ? "" : option?.ProgramName
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Program"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5}>
              <p className={classes.fieldText}>Site : </p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                blurOnSelect
                disablePortal
                options={siteData}
                value={selectedSite}
                onChange={(event, value) => {
                  if (value) {
                    setSelectedSite(value);
                  } else {
                    setSelectedSite(initialSiteValue);
                  }
                }}
                getOptionLabel={(option) =>
                  option?.GeoLocCd === ""
                    ? ""
                    : `${option?.GeoLocName + " (" + option?.GeoLocCd + ")"}`
                }
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Site"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={1}>
              <p className={classes.fieldText}>Project :</p>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                blurOnSelect
                disablePortal
                value={projectValue}
                options={projectData}
                onChange={(event, value) => {
                  if (value) {
                    setProjectValue(value);
                  } else {
                    setProjectValue(initialProjectValue);
                  }
                }}
                getOptionLabel={(option) =>
                  option?.ProjectName === "" ? "" : option?.ProjectName
                }
                sx={{
                  opacity: 1,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "gray",
                  borderRadius: 32,
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Project"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 32,
                        border: "1px solid #d3d3d3",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5} />
            <Grid item xs={1.5}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="medium"
                    id="active"
                    checked={frameworkStatus?.active}
                    onChange={handleStatusCheckbox}
                  />
                }
                label={"Active Frameworks"}
              ></FormControlLabel>
            </Grid>
            <Grid item xs={1.5}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="medium"
                    id="future"
                    checked={frameworkStatus?.future}
                    onChange={handleStatusCheckbox}
                  />
                }
                label={"Future Frameworks"}
              ></FormControlLabel>
            </Grid>
            <Grid item xs={1.5}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="medium"
                    id="expired"
                    checked={frameworkStatus?.expired}
                    onChange={handleStatusCheckbox}
                  />
                }
                label={"Expired Frameworks"}
              ></FormControlLabel>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1}>
              <CustomButton
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={handleFindFrameworks}
              >
                Search
              </CustomButton>
            </Grid>
            <Grid item xs={1}>
              <CustomOutlinedButton
                variant="outlined"
                size="small"
                startIcon={<RestartAltIcon />}
                onClick={handleReset}
              >
                Reset
              </CustomOutlinedButton>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Grid container rowSpacing={0.8}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={0.2} />
        <Grid item xs={1}>
          <CustomOutlinedButton
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleExportClick}
            disabled={rows.length === 0}
          >
            EXPORT
          </CustomOutlinedButton>
        </Grid>
        <Grid item xs={0.1}></Grid>
        <Grid item xs={2}>
          <CustomButton
            variant="contained"
            startIcon={<AddIcon />}
            disabled={readOnlyFramework}
            onClick={handleCreateNewFramework}
          >
            Create Framework
          </CustomButton>
        </Grid>

        <div className={classes.primeReactGridContainer}>
          <PrimeReactDataGrid
            value={rows}
            size="small"
            showGridlines
            removableSort
            resizableColumns
            columnResizeMode="expand"
            dataKey="id"
            columns={columns}
            filterprops={filterProps}
            {...(rows.length > 0 && { footer: footer })}
            globalFilterFields={[
              "framework",
              "description",
              "effectiveDate",
              "expiredDate",
              "country",
              "site",
              "parentClient",
              "client",
              "program",
              "project",
              "createdBy",
              "createdDate",
              "modifiedBy",
              "modifiedDate",
            ]}
            sortMode="multiple"
            tableStyle={{ minWidth: "10rem" }}
            emptyMessage="No records found."
            scrollable
            scrollHeight="650px"
            virtualScrollerOptions={{
              itemSize: 46,
              style: { minHeight: "650px" },
            }}
          ></PrimeReactDataGrid>
        </div>
      </Grid>

      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      <Drawer
        anchor="right"
        open={panelOpen}
        onClose={handleSidePanelClose}
        PaperProps={{
          sx: { width: "20%" },
        }}
      >
        {panelType === "site" ? (
          <PrepareSiteContent details={panelDetails} />
        ) : (
          <PrepareProjectContent details={panelDetails} />
        )}
      </Drawer>
    </>
  );
}
